import { createApp } from 'vue'
import App from './App.vue'
import './styles/index.scss';


if(process.env.NODE_ENV === 'development') {
    require('bootstrap/dist/js/bootstrap.js') ;
}

/** HELPERS - Utillities*/
import * as Utils from '@/utils';

/** HELPERS - Chart Config*/
import * as ChartConfig from '@/utils/config.charts';

const app = createApp(App);
app.config.globalProperties.$utils = Utils;
app.config.globalProperties.$chartconfig = ChartConfig;
app.mount('#kpiapp');

